<template>
	<f7-page class="webdebtorlist" id="debtorList">
		<page-nav-bar currentServiceName="MoneyRoad" popoverName=".popoverContacts" subNavTitle="Other Debtors LALA" :menuAccess="false"></page-nav-bar>
    <!-- <f7-navbar title="Other debtors" back-link=" "></f7-navbar> -->
    <!-- <div class="navbar">
        <div class="navbar-inner">
            <div class="center">Other debtors</div>
            <div class="right">
                <a href="#" class="link" @click="goBack">OK</a>
            </div>
        </div>
    </div> -->
		<f7-searchbar class=""
			cancel-link="Cancel"
			search-list="#debtors-list"
			placeholder="Search in debtor list"
			@searchbar:search="onSearch">
		</f7-searchbar>
    <f7-list id="debtors-list" class="">
      <!-- <f7-list-item
      swipeout
      v-for="(debtor, index) in debtors"
      :title="debtor.debtorName"
      :subtitle="debtor.debtorEmail"
      :key="debtor.debtorBank"
      @swipeout:deleted="removeDebtor(index)">
        <f7-swipeout-actions>
          <f7-swipeout-button delete>Delete</f7-swipeout-button>
        </f7-swipeout-actions>
      </f7-list-item> -->
      <!-- TODO -->
      <li
      class="item-content"
      v-for="(debtor, index) in debtors"
      :key="debtor.debtorBank">
        <div class="item-inner">
          <div class="item-title">{{ debtor.debtorName }}</div>
          <div class="item-after"><i class="f7-icons color-red" @click="removeDebtor(index)">close_round_fill</i></div>
        </div>
      </li>
      <!-- TODO -->
    </f7-list>
	</f7-page>
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'

export default {
  name: 'debtorList',
  components: {
    'page-nav-bar': pageNavBar
  },
  data: () => {
    return {
      debtors: []
    }
  },
  created () {
    // const that = this
    // this.$bus.$on('refresh-cache-contacts', () => {
    //   that.setContacts()
    // })
    this.debtors = this.$engine.services.payments.debtorList
  },
  methods: {
    onSearch: function (query, found) {
      var self = this
      for (var k in self.contacts) {
        if (self.contacts.hasOwnProperty(k)) {
          for (var i = 0; i < self.contacts[k].length; i++) {
            if (self.contacts[k][i].label.indexOf(query) >= 0 || self.contacts[k][i].name.indexOf(query) >= 0 || query.trim() === '') {
              if (!found.hasOwnProperty(self.contacts[k])) {
                found[self.contacts[k]] = []
              }
              found[self.contacts[k]].push(self.contacts[k][i].id)
            }
          }
        }
      }
      return found
    },
    removeDebtor (key) {
      this.$engine.services.payments.debtorList.splice(key, 1)
    },
    goBack () {
      // this.$bus.emit('refresh-debtor-contact-list', this.contactDebtors)
      this.$f7.mainView.router.back()
    }
  }
}
</script>



// WEBPACK FOOTER //
// CMDebtorList.vue?2aedbaef